import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  Tabs,
  Tab,
  Card,
  Grid,
  MenuItem,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Switch
} from "@mui/material";
import { useContext, useEffect, useState, useMemo } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { useParams, useLocation } from "react-router-dom";
import { analiticsFilterApi } from "../../store/analytics/filters";
import { schoolTypeListApi } from "../../store/analytics/schoolTypeList";
import { analyticsGraphApi } from "../../store/analytics/analyticsGraphDetail";
import { analyticsTableApi } from "../../store/analytics/analyticsList";
import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import HealthCheck from "./HealthCheck";
import IndividualContent from "./IndividualContent";
import ContentConsumptionNonGraded from "./ContentConsumptionNonGraded";
import CommunityEngagement from "./CommunityEngagement";
import AppErrors from "./AppErrors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { classGlobalApi } from "../../store/class/classListGlobal";
import { subjectGlobalApi } from "../../store/subject/subjectListGlobal";
import apiRoutes from "../../store/apiConfigs";
import { fetchUserMaskStatusApi, userDataMaskUnmaskApi } from "../../store/userDataMasking/userDataMaskUnmask";
import { AuthContext } from "../../context/AuthContext";
import { individualContentGraphApi } from "../../store/analytics/IndividualContentGraph";
import { communityEngagementGraphApi } from "../../store/analytics/CommunityEngagementGraph";
import { contentConsumptionGraphApi } from "../../store/analytics/contentConsumptionNonGraded";
import { courseProgressGraphApi } from "../../store/analytics/CourseProgressGraph";
import { impactSummaryGraphApi } from "../../store/analytics/impactSummaryGraph";
import { userRetentionGraphApi } from "../../store/analytics/userRetentionGraph";
import { usageSummaryGraphApi } from "../../store/analytics/UsageSummaryGraph";
import { teacherLoungeGraphApi } from "../../store/analytics/TeacherLoungeGraph";
import CourseProgress from "./CourseProgress";
import TeacherLounge from "./Teacher Lounge";
import ImpactSummary from "./ImpactSummary";
import UserRetention from "./UserRetention";
import UsageSummary from "./UsageSummary"
import ContentConsumptionGraded from "./ContentConsumptionGraded";
import usePermission from "../../hooks/usePermission";

const data = [
  {
    name: "January",
    uv: 4000,
    pv: 2400,
    nv: 2400,
    amt: 2400,
  },
  {
    name: "Fabruary",
    uv: 3000,
    pv: 1398,
    nv: 2400,
    amt: 2210,
  },
  {
    name: "March",
    uv: 2000,
    pv: 9800,
    nv: 4040,
    amt: 2290,
  },
  {
    name: "April",
    uv: 2780,
    pv: 3908,
    nv: 2400,
    amt: 2000,
  },
  {
    name: "May",
    uv: 1890,
    pv: 4800,
    nv: 2400,
    amt: 2181,
  },
  {
    name: "June",
    uv: 2390,
    pv: 3800,
    nv: 9090,
    amt: 2500,
  },
  {
    name: "July",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  },
  {
    name: "august",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "September",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "October",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "November",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "December",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  },
];
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
//  TLM, Teaching Videos, Lessons Plans, Worksheet, 
const GradedModules = [
  // { name: "Learning material", value: "learning_material" },
  // { name: "TLM", value: "tlm" },
  { name: "Teaching Videos", value: "teaching_videos", permissionModule: "teaching_resources" },
  { name: "Lesson Plans", value: "lesson_plan", permissionModule: "lesson_plan" },
  { name: "Worksheets", value: "worksheet", permissionModule: "worksheet" },
  { name: "Learning Material", value: "learning_material", permissionModule: "tlm" },
  { name: "Project Based", value: "project_based", permissionModule: "pbl" },
  { name: "Entry Exit Questions", value: "entry_exit_questions", permissionModule: "entry_exit" },
  { name: "Homework", value: "homework", permissionModule: "home_work" },
  { name: "School Process", value: "school_process", permissionModule: "integrated_school_process" },
  { name: "No Bag Activity", value: "no_bag_activity", permissionModule: "no_bag_activity" },
  { name: "Check Your Understanding", value: "check_your_understanding", permissionModule: "check_your_understanding" },
  { name: "Misconceptions", value: "misconceptions", permissionModule: "misconception" },
  { name: "Action Research", value: "action_research", permissionModule: "action_research" },
  { name: "Question Bank", value: "question_bank", permissionModule: "question_bank" },
]

// Courses, Podcast, short video, Quizzes, Webinar, 
const nonGradedModules = [
  { name: "Courses", value: "course", permissionModule: "courses" },
  { name: "Podcasts", value: "podcast", permissionModule: "podcast" },
  { name: "Short Videos", value: "short_videos", permissionModule: "short_videos" },
  { name: "Quizzes", value: "quiz", permissionModule: "quizzes" },
  { name: "Webinars", value: "webinar", permissionModule: "webinar" },

]
const communityModules = [
  { name: "Impact Stories", value: "impact_stories" },
  { name: "PodCast", value: "podcast" },
  { name: "Sunday Polls", value: "sunday_polls" },
  { name: "Short Videos", value: "short_videos" },
  { name: "Quiz", value: "quiz" },
  { name: "Webinar", value: "webinar" },
  { name: "School Processes", value: "school_process" },
  { name: "Courses", value: "course" },
  { name: "Teaching Videos", value: "teaching_videos" },
  { name: "Learning material", value: "learning_material" },
  { name: "Project Based", value: "project_based" },
  { name: "Entry Exit", value: "entry_exit_questions" },
  { name: "Home Work", value: "home_work" },
  { name: "Worksheet", value: "worksheet" },
  { name: "Lesson Plan", value: "lesson_plan" },
  { name: "No bag Activity", value: "no_bag_activity" },
  { name: "Check Your Understanding", value: "check_your_understanding" },
]
const individualContentModalList = [
  { name: "Sunday Polls", value: "sunday_polls" },
  { name: "Quiz", value: "quiz" },
  { name: "Webinar", value: "webinar" },
  { name: "AI Resources", value: "ai_resources" },

]
const reportTypes = [
  { name: "User report", value: "user_report" },
  { name: "Content report", value: "content_report" },
  { name: "Content based user report", value: "user_content_report" },
  { name: "Content report (Channel)", value: "channel_content_report" },
  { name: "Content based user report (Channel)", value: "channel_user_content_report" },
  { name: "AI-Resources Content Consumption user report", value: "ai_resources" },
  { name: "Quick Access report", value: "quick_access" },
]

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AnalyticsListing() {
  const analyticsFilter = useSelector((state) => state?.analyticsFilter);
  const { result: filterResult, filterLoading } = analyticsFilter;
  const analyticsGraph = useSelector((state) => state?.analyticsGraph);
  const { result: graphResult, graphLoading } = analyticsGraph;
  const schoolTypeList = useSelector((state) => state?.schoolTypeList);
  const { result: schoolTypeResult, loading: schoolTypeLoading } = schoolTypeList;
  const individualContentGraph = useSelector((state) => state?.individualContentGraph);
  const { result: individualGraphResult, graphLoading: individualGraphLoading } = individualContentGraph;
  const courseProgressGraph = useSelector((state) => state?.courseProgressGraph);
  const { result: courseProgressGraphResult, graphLoading: courseProgressGraphLoading } = courseProgressGraph;
  const impactSummaryGraph = useSelector((state) => state?.impactSummaryGraph);
  const { result: impactSummaryGraphResult, graphLoading: impactSummaryGraphLoading } = impactSummaryGraph;
  const userRetentionGraph = useSelector((state) => state?.userRetentionGraph);
  const { result: userRetentionGraphResult, graphLoading: userRetentionGraphLoading } = userRetentionGraph;
  const usageSummaryGraph = useSelector((state) => state?.usageSummaryGraph);
  const { result: usageSummaryGraphResult } = usageSummaryGraph || {};
  const contentConsumptionGraph = useSelector((state) => state?.contentConsumptionGraph);
  const { result: contentGraphResult } = contentConsumptionGraph || {};

  const [error, setError] = useState(null);
  const { result: classList, loading: classLoading } = useSelector((state) => state?.classGlobal);
  const { result: subjectList, loading: subjectLoading } = useSelector((state) => state?.subjectGlobal);

  const schema = yup
    .object({})
    .required();
  const schemaEdit = yup
    .object({})
    .required();
  const params = useParams();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(params.id ? schemaEdit : schema),
    defaultValues: {},
  });

  const maskingStatus = useSelector((state) => state?.userDataMaskUnmask);
  const {
    result: maskingResult,
    loading: maskingLoading,
    message: maskingMessage,
    isDataMasked,
  } = maskingStatus;

  const [value, setValue] = useState(0);
  const location = useLocation();
  const [cat, setCat] = useState();
  const [classs, setClasss] = useState();
  const [subject, setSubject] = useState();
  const [state, setState] = useState();
  const [module, setModule] = useState("learningmaterial");
  const [nonGradedModule, setNonGradedModule] = useState(nonGradedModules[0]?.value);
  const [communityModule, setCommunityModule] = useState("short_videos");
  const [contentType, setContentType] = useState("non-graded");
  const [individualContentModal, setIndividualContentModal] = useState('sunday_polls');
  const [schoolType, setSchoolType] = useState();
  const [platform, setPlatform] = useState();
  const [language, setLanguage] = useState();
  const [userType, setUserType] = useState();
  const [isDownload, setIsDownload] = useState(false)
  const [reportType, setReportType] = useState("user_report");
  const [monthDaily, setMonthDaily] = useState("monthly");
  const [monthYearly, setMonthYearly] = useState("monthly");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const { userData } = useContext(AuthContext);
  const isSuperUser = Boolean(userData?.is_superuser);
  const { can } = usePermission();
  const allowedGradedModules = useMemo(() => GradedModules.filter(({ permissionModule }) => (
    isSuperUser || can(permissionModule, "analytics")
  )), [can, isSuperUser]);
  const allowedNonGradedModules = useMemo(() => nonGradedModules.filter(({ permissionModule }) => (
    isSuperUser || can(permissionModule, "analytics")
  )), [can, isSuperUser]);

  // Date range constraint: max 1 month range
  const toMaxDate = startDate
    ? (dayjs(startDate).add(1, 'month').isAfter(dayjs()) ? dayjs() : dayjs(startDate).add(1, 'month'))
    : dayjs();
  const [region, setRegion] = useState();
  const [isMaskingEnabled, setIsMaskingEnabled] = useState(isDataMasked);

  useEffect(() => {
    const availableModules = contentType === "graded" ? allowedGradedModules : allowedNonGradedModules;
    if (availableModules.length > 0 && !availableModules.some(({ value }) => value === nonGradedModule)) {
      setNonGradedModule(availableModules[0].value);
    }
    if (contentType === "graded" && allowedGradedModules.length === 0 && allowedNonGradedModules.length > 0) {
      setContentType("non-graded");
      setNonGradedModule(allowedNonGradedModules[0].value);
    }
    if (contentType === "non-graded" && allowedNonGradedModules.length === 0 && allowedGradedModules.length > 0) {
      setContentType("graded");
      setNonGradedModule(allowedGradedModules[0].value);
    }
  }, [allowedGradedModules, allowedNonGradedModules, contentType, nonGradedModule]);

  const categories = useSelector((state) => state?.categories);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleMasking = async () => {
    const payload = {
      "is_data_masked": !isMaskingEnabled
    }

    await dispatch(userDataMaskUnmaskApi(payload));
    // setTimeout(() => {
    await setIsMaskingEnabled(!isMaskingEnabled);
    // }, 1000);
  }
  useEffect(() => {
    const { tabIndex } = location.state || {};
    const storedTabIndex = sessionStorage.getItem('analyticsTabIndex');

    if (tabIndex !== undefined) {
      setValue(tabIndex);
    } else if (storedTabIndex) {
      setValue(parseInt(storedTabIndex));
    } else {
      setValue(0);
    }

    // Clean up stored tab index after reading
    if (storedTabIndex) {
      sessionStorage.removeItem('analyticsTabIndex');
    }
  }, [location.key, location.pathname]);

  useEffect(() => {
    if (maskingStatus?.isDataMasked) {
      setIsMaskingEnabled(maskingStatus?.isDataMasked)
    }
  }, [maskingStatus?.isDataMasked])

  useEffect(() => {
    if (value === 3) {
      dispatch(analiticsFilterApi({ type: "city" }));
    } else {
      dispatch(analiticsFilterApi({
        type: "filters", params: {
          start_date: startDate,
          end_date: endDate
        }
      }));

    }
    if (value === 5) {
      dispatch(analiticsFilterApi());

    }

    if (value === 5 || value === 6 || value === 7 || value === 8) {
      dispatch(schoolTypeListApi());
    }

  }, [value])

  useEffect(() => {

    switch (value) {
      case 0:
        dispatch(analyticsGraphApi({
          type: "health",
          params: {
            analytics_type: "health_check",
            city: region,
            region: state,
            frequency: (startDate || endDate) ? "daily" : monthDaily,
            start_date: startDate,
            end_date: endDate
          }
        }));
        break;
      case 1:
        dispatch(contentConsumptionGraphApi({
          params: {
            graph_type: "module_overview",
            period: monthDaily,
            content_type: nonGradedModule,
            start_date: startDate,
            end_date: endDate,
            city: region,
            state: state
          }
        }));
        break;
      case 2:
        dispatch(communityEngagementGraphApi({
          params: {
            graph_type: "time_series",
            period: monthDaily,
            content_type: communityModule || "course",
            city: region,
            state: state
          }
        }));
        break;
      case 3:
        dispatch(analyticsGraphApi({
          type: "community",
          params: {
            analytics_type: "google_analytics",
            module: communityModule,
            city: region,
            region: state,
            frequency: monthDaily,
            start_date: startDate,
            end_date: endDate
          }
        }));
        break;
      case 4:
        // batch report - no graph API needed
        break;
      case 5:
        dispatch(individualContentGraphApi({
          type: "individual_report",
          params: {
            // analytics_type: "google_analytics",
            module: individualContentModal,
            region: region,
            state: state,
            frequency: monthDaily,
            start_date: startDate,
            end_date: endDate,
            school_type: schoolType,

          }
        }));
        break;
      case 6:
        dispatch(courseProgressGraphApi({
          type: "course_progress",
          params: {
            // analytics_type: "google_analytics",
            // module: individualContentModal,
            school_type: schoolType,
            region: region,
            state: state,
            frequency: monthDaily,
            start_date: startDate,
            end_date: endDate,

          }
        }));
        break;
      case 7:
        dispatch(teacherLoungeGraphApi({
          params: {
            period: 'monthly',
            graph_type: 'by_role',
            state: state,
            city: region,
            start_date: startDate,
            end_date: endDate,
            role: userType,
          }
        }));
        break;
      case 8:
        dispatch(impactSummaryGraphApi({
          type: "impact_summary",
          params: {
            school_type: schoolType,
            region: region,
            state: state,
            frequency: monthDaily,
            start_date: startDate,
            end_date: endDate,

          }
        }));
        break;
      case 9:
        dispatch(userRetentionGraphApi({
          type: "user_retention",
          params: {
            school_type: schoolType,
            region: region,
            state: state,
            frequency: monthYearly,
            start_date: startDate,
            end_date: endDate,

          }
        }));
        break;
      case 10:
        dispatch(usageSummaryGraphApi({
          params: {
            graph_type: "by_platform",
            state: state,
            period: monthDaily,
            city: region,
            start_date: startDate,
            end_date: endDate,
            platform: platform,
          }
        }));
        break;
      default:
        dispatch(analyticsGraphApi({
          type: "health",
          params: {
            analytics_type: "health_check",
            city: region,
            region: state,
            frequency: (startDate || endDate) ? "daily" : monthDaily
          }
        }));
        dispatch(analyticsTableApi({
          type: "health",
          params: {
            analytics_type: "registration_stats",
            city: region,
            region: state,
            frequency: (startDate || endDate) ? "daily" : monthDaily
          }
        }));
    }

  }, [dispatch,
    cat,
    state,
    monthDaily,
    region,
    value,
    module,
    classs,
    subject,
    startDate,
    endDate,
    nonGradedModule,
    communityModule,
    individualContentModal,
    schoolType,
    platform,
    language,
    monthYearly,
    userType
  ]);

  const handleClear = async () => {
    setClasss()
    setSubject()
    setState()
    setModule("learningmaterial")
    setMonthDaily("monthly")
    setStartDate()
    setEndDate()
    setRegion()
    setCommunityModule("short_videos")
    // setNonGradedModule(nonGradedModules[0]?.value)
    setSchoolType()
    setPlatform()
    setUserType()
    setLanguage()
    // setIndividualContentModal()
  };

  const handleApiCall = async () => {
    try {
      let apiUrl;
      if (reportType === "quick_access") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}${apiRoutes.quickAccessReport}?download=csv`;
      } else {
        let query = {
          report: reportType
        };
        const params = new URLSearchParams(query);
        const queryString = params.toString();
        apiUrl = `${process.env.REACT_APP_BASE_URL}${apiRoutes.adminAction("report-download", 1)}?${queryString}`;
      }

      setIsDownload(true);
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        setIsDownload(false);
        throw new Error('Network response was not ok');
      }

      const blob = await response.json();
      // Create a URL for the file
      const url = blob.result;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `batchreport_${reportType}_${new Date().getTime()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsDownload(false);
    } catch (error) {
      console.error('Error exporting data:', error);
      setIsDownload(false);
      alert('Failed to export data.');
    }
  };

  useEffect(() => {
    dispatch(classGlobalApi());
    dispatch(subjectGlobalApi());
    dispatch(fetchUserMaskStatusApi())
  }, [dispatch])

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>

        <Stack direction="col" spacing={1} sx={{ my: 2, }} justifyContent="space-between">
          <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
            <HiTemplate size={30} />
            <Typography>Analytics Dashboard</Typography>
          </Stack>
          {isSuperUser && (
            <FormControlLabel
              control={
                <Switch
                  checked={isMaskingEnabled}
                  onChange={(e) => handleMasking(e.target.checked)}
                  name="maskingSwitch"

                />
              }
              label="Enable Masking"
              labelPlacement="start"
            />
          )}
        </Stack>

        <Paper elevation={0}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              {/* tabs header name  */}
              <Tabs value={value} onChange={handleChange} aria-label="analytics tabs" variant="scrollable" scrollButtons
                allowScrollButtonsMobile >
                <Tab label="Health Check" {...a11yProps(0)} value={0} />
                <Tab label="Content Consumption" {...a11yProps(1)} value={1} />
                {/* <Tab label="Content Consumption - Graded" {...a11yProps(1)} value={11} /> */}
                <Tab label="Community Engagement" {...a11yProps(2)} value={2} />
                <Tab label="Batch Reports" {...a11yProps(4)} value={4} />
                <Tab label="App Errors" {...a11yProps(3)} value={3} />
                <Tab label="Individual Content" {...a11yProps(5)} value={5} />
                <Tab label="Course Progress" {...a11yProps(6)} value={6} />
                <Tab label="Teacher Lounge" {...a11yProps(7)} value={7} />
                <Tab label="Impact Summary" {...a11yProps(8)} value={8} />
                <Tab label="User Retention" {...a11yProps(9)} value={9} />
                <Tab label="Usage Summary" {...a11yProps(10)} value={10} />
              </Tabs>
            </Box>
            {/* health check */}
            <CustomTabPanel value={value} index={0}>
              <form id="outer_form_health_check">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Monthly/Daily</InputLabel>
                          <Select
                            {...register("monthDaily")}
                            label="Monthly/Daily"
                            id="outlined-adornment-monthDaily"
                            value={monthDaily ? monthDaily : null}
                            notched
                            error={errors?.monthDaily?.message}
                            onChange={(e) => setMonthDaily(e.target.value)}
                            disabled={!!startDate || !!endDate}
                          >
                            {[{ label: "Monthly", value: "monthly" }, { label: "Daily", value: "daily" }]?.map((item, index) => (
                              <MenuItem value={item.value} key={index} sx={{ textTransform: "capitalize" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.monthDaily?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              disableFuture={true}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <HealthCheck graphData={graphResult} type={monthDaily} monthDaily={monthDaily} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} />
            </CustomTabPanel>
            {/* LIVE content consumption non graded */}
            <CustomTabPanel value={value} index={1}>
              <form id="outer_form_contect_consumption_nongraded">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Monthly/Daily</InputLabel>
                          <Select
                            {...register("monthDaily")}
                            label="Monthly/Daily"
                            id="outlined-adornment-monthDaily"
                            value={monthDaily ? monthDaily : null}
                            notched
                            error={errors?.monthDaily?.message}
                            onChange={(e) => setMonthDaily(e.target.value)}
                            disabled={!!startDate || !!endDate}
                          >
                            {[{ label: "Monthly", value: "monthly" }, { label: "Daily", value: "daily" }]?.map((item, index) => (
                              <MenuItem value={item.value} key={index} sx={{ textTransform: "capitalize" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.monthDaily?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Content Type</InputLabel>
                          <Select
                            label="Content Type"
                            id="outlined-adornment-contentType"
                            value={contentType}
                            notched
                            onChange={(e) => {
                              const val = e.target.value;
                              setContentType(val);
                              if (val === 'non-graded') {
                                setNonGradedModule(allowedNonGradedModules[0]?.value);
                              } else {
                                setNonGradedModule(allowedGradedModules[0]?.value);
                              }
                            }}
                          >
                            {allowedNonGradedModules.length > 0 && <MenuItem value="non-graded">Non-Graded</MenuItem>}
                            {allowedGradedModules.length > 0 && <MenuItem value="graded">Graded</MenuItem>}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Type</InputLabel>
                          <Select
                            {...register("module")}
                            label="Type"
                            id="outlined-adornment-module"
                            value={nonGradedModule ? nonGradedModule : null}
                            notched
                            onChange={(e) => setNonGradedModule(e.target.value)}
                          >
                            {(contentType === 'non-graded' ? allowedNonGradedModules : allowedGradedModules)?.map(({ name, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {name}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <ContentConsumptionNonGraded graphData={contentGraphResult} type={monthDaily} module={nonGradedModule} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} />
            </CustomTabPanel>

            {/*  content consumption graded */}
            {/* <CustomTabPanel value={value} index={11}>
              <form id="outer_form_contect_consumption_nongraded">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Monthly/Daily</InputLabel>
                          <Select
                            {...register("monthDaily")}
                            label="Monthly/Daily"
                            id="outlined-adornment-monthDaily"
                            value={monthDaily ? monthDaily : null}
                            notched
                            error={errors?.monthDaily?.message}
                            onChange={(e) => setMonthDaily(e.target.value)}
                          >
                            {[{ label: "Monthly", value: "monthly" }, { label: "Daily", value: "daily" }]?.map((item, index) => (
                              <MenuItem value={item.value} key={index} sx={{ textTransform: "capitalize" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.monthDaily?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Resources</InputLabel>
                          <Select
                            {...register("module")}
                            label="Resources"
                            id="outlined-adornment-module"
                            value={nonGradedModule ? nonGradedModule : null}
                            notched
                            defaultValue={GradedModules[0].value}
                            onChange={(e) => setNonGradedModule(e.target.value)}
                          >
                            {GradedModules?.map(({ name, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {name}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <ContentConsumptionGraded graphData={graphResult} type={monthDaily} module={nonGradedModule} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} />
            </CustomTabPanel> */}

            {/* community engagement */}
            <CustomTabPanel value={value} index={2}>
              <form id="outer_form_community_engagement">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Monthly/Daily</InputLabel>
                          <Select
                            {...register("monthDaily")}
                            label="Monthly/Daily"
                            id="outlined-adornment-monthDaily"
                            value={monthDaily ? monthDaily : null}
                            notched
                            error={errors?.monthDaily?.message}
                            onChange={(e) => setMonthDaily(e.target.value)}
                          >
                            {[{ label: "Monthly", value: "monthly" }, { label: "Daily", value: "daily" }]?.map((item, index) => (
                              <MenuItem value={item.value} key={index} sx={{ textTransform: "capitalize" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.monthDaily?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <CommunityEngagement graphData={graphResult} type={monthDaily} monthDaily={monthDaily} module={communityModule} region={region} state={state} isMaskingEnabled={isMaskingEnabled} />
            </CustomTabPanel>
            {/* batch reports  */}
            <CustomTabPanel value={value} index={4}>
              <form id="outer_form_batch_report">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Report Type</InputLabel>
                          <Select
                            {...register("reportType")}
                            label="Report Type"
                            id="outlined-adornment-module"
                            value={reportType ? reportType : null}
                            notched
                            defaultValue={reportTypes[0].value}
                            onChange={(e) => setReportType(e.target.value)}
                          >
                            {reportTypes?.map(({ name, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {name}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.reportType?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleApiCall()} variant="outlined">Download Report</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
            </CustomTabPanel>
            {/* app errors */}
            <CustomTabPanel value={value} index={3}>
              <form id="outer_form_app_errors">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <AppErrors data={data} startDate={startDate} endDate={endDate} />
            </CustomTabPanel>
            {/* individual content  */}
            <CustomTabPanel value={value} index={5}>
              <form id="outer_form_health_check">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Resources</InputLabel>
                          <Select
                            {...register("module")}
                            label="Resources"
                            id="outlined-adornment-module"
                            value={individualContentModal ? individualContentModal : null}
                            notched
                            // defaultValue={individualContentModalList[0].value}
                            onChange={(e) => setIndividualContentModal(e.target.value)}
                          >
                            {individualContentModalList?.map(({ name, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {name}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>School type</InputLabel>
                          <Select
                            {...register("module")}
                            label="Resources"
                            id="outlined-adornment-module"
                            value={schoolType ? schoolType : null}
                            notched
                            onChange={(e) => setSchoolType(e.target.value)}
                          >
                            {schoolTypeResult?.map(({ title, id }, index) => (
                              <MenuItem value={id} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Monthly/Daily</InputLabel>
                          <Select
                            {...register("monthDaily")}
                            label="Monthly/Daily"
                            id="outlined-adornment-monthDaily"
                            value={monthDaily ? monthDaily : null}
                            notched
                            error={errors?.monthDaily?.message}
                            onChange={(e) => setMonthDaily(e.target.value)}
                          >
                            {[{ label: "Monthly", value: "monthly" }, { label: "Daily", value: "daily" }]?.map((item, index) => (
                              <MenuItem value={item.value} key={index} sx={{ textTransform: "capitalize" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.monthDaily?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid> */}
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <IndividualContent graphData={individualGraphResult} type={monthDaily} monthDaily={monthDaily} module={individualContentModal} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} schoolType={schoolType} />
            </CustomTabPanel>
            {/* Course Progress */}
            <CustomTabPanel value={value} index={6}>
              <form id="outer_form_health_check">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>School type</InputLabel>
                          <Select
                            {...register("module")}
                            label="Resources"
                            id="outlined-adornment-module"
                            value={schoolType ? schoolType : null}
                            notched
                            onChange={(e) => setSchoolType(e.target.value)}
                          >
                            {schoolTypeResult?.map(({ title, id }, index) => (
                              <MenuItem value={id} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <CourseProgress graphData={courseProgressGraphResult} type={monthDaily} monthDaily={monthDaily} module={individualContentModal} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} schoolType={schoolType} />
            </CustomTabPanel>
            {/* Teacher Lounge */}
            <CustomTabPanel value={value} index={7}>
              <form id="outer_form_health_check">
                <Grid container spacing={2}>
                  {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>School type</InputLabel>
                          <Select
                            {...register("module")}
                            label="Resources"
                            id="outlined-adornment-module"
                            value={schoolType ? schoolType : null}
                            notched
                            onChange={(e) => setSchoolType(e.target.value)}
                          >
                            {schoolTypeResult?.map(({ title, id }, index) => (
                              <MenuItem value={id} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid> */}
                  {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Platform</InputLabel>
                          <Select
                            {...register("platform")}
                            label="Platform"
                            id="outlined-adornment-platform"
                            value={platform ? platform : null}
                            notched
                            onChange={(e) => setPlatform(e.target.value)}
                          >
                            {[
                              { label: 'iOS', value: 'ios' },
                              { label: 'Android', value: 'android' },
                              { label: 'Website', value: 'website' },
                            ]?.map(({ label, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid> */}
                  {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>User Type</InputLabel>
                          <Select
                            {...register("userType")}
                            label="User Type"
                            id="outlined-adornment-usertype"
                            value={userType ? userType : null}
                            notched
                            onChange={(e) => setUserType(e.target.value)}
                          >
                            {[{ label: 'Teacher', value: 'teacher' }, { label: 'Parent', value: 'parent' }, { label: 'Educator', value: 'educator' }]?.map(({ label, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid> */}
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid> */}
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <TeacherLounge graphData={individualGraphResult} type={monthDaily} monthDaily={monthDaily} module={individualContentModal} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} schoolType={schoolType} platform={platform} userType={userType} />
            </CustomTabPanel>
            {/* Impact Summary */}
            <CustomTabPanel value={value} index={8}>
              <form id="outer_form_health_check">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>School type</InputLabel>
                          <Select
                            {...register("module")}
                            label="Resources"
                            id="outlined-adornment-module"
                            value={schoolType ? schoolType : null}
                            notched
                            onChange={(e) => setSchoolType(e.target.value)}
                          >
                            {schoolTypeResult?.map(({ title, id }, index) => (
                              <MenuItem value={id} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Language</InputLabel>
                          <Select
                            {...register("language")}
                            label="Language"
                            id="outlined-adornment-language"
                            value={language ? language : null}
                            notched
                            onChange={(e) => setLanguage(e.target.value)}
                          >
                            {[
                              { label: 'English', value: 'english' },
                              { label: 'Hindi', value: 'hindi' },
                              { label: 'Both', value: 'both' },
                            ]?.map(({ label, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <ImpactSummary graphData={impactSummaryGraphResult} type={monthDaily} monthDaily={monthDaily} module={individualContentModal} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} schoolType={schoolType} platform={platform} language={language} userType={userType} />
            </CustomTabPanel>
            {/* User Retention */}
            <CustomTabPanel value={value} index={9}>
              <form id="outer_form_health_check">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Monthly/Yearly</InputLabel>
                          <Select
                            {...register("monthYearly")}
                            label="Monthly/Yearly"
                            id="outlined-adornment-monthYearly"
                            value={monthYearly ? monthYearly : null}
                            notched
                            error={errors?.monthYearly?.message}
                            onChange={(e) => setMonthYearly(e.target.value)}
                          >
                            {[{ label: "Monthly", value: "monthly" }, { label: "Yearly", value: "yearly" }]?.map((item, index) => (
                              <MenuItem value={item.value} key={index} sx={{ textTransform: "capitalize" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.monthYearly?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <UserRetention graphData={userRetentionGraph} type={monthDaily} monthDaily={monthDaily} module={individualContentModal} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} schoolType={schoolType} platform={platform} language={language} userType={userType} />
            </CustomTabPanel>
            {/* Usage Summary */}
            <CustomTabPanel value={value} index={10}>
              <form id="outer_form_health_check">
                <Grid container spacing={2}>
                  {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Monthly/Yearly</InputLabel>
                          <Select
                            {...register("monthYearly")}
                            label="Monthly/Yearly"
                            id="outlined-adornment-monthYearly"
                            value={monthYearly ? monthYearly : null}
                            notched
                            error={errors?.monthYearly?.message}
                            onChange={(e) => setMonthYearly(e.target.value)}
                          >
                            {[{ label: "Monthly", value: "monthly" }, { label: "Yearly", value: "yearly" }]?.map((item, index) => (
                              <MenuItem value={item.value} key={index} sx={{ textTransform: "capitalize" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.monthYearly?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid> */}
                  {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Platform</InputLabel>
                          <Select
                            {...register("platform")}
                            label="Platform"
                            id="outlined-adornment-platform"
                            value={platform ? platform : null}
                            notched
                            onChange={(e) => setPlatform(e.target.value)}
                          >
                            {[
                              { label: 'iOS', value: 'ios' },
                              { label: 'Android', value: 'android' },
                              { label: 'Website', value: 'web' },
                            ]?.map(({ label, value }, index) => (
                              <MenuItem value={value} key={index}>
                                {label}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.category?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid> */}
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>State</InputLabel>
                          <Select
                            {...register("state")}
                            label="State"
                            id="outlined-adornment-state"
                            value={state ? state : null}
                            notched
                            error={errors?.state?.message}
                            onChange={(e) => setState(e.target.value)}
                          >
                            {Object.keys(filterResult)?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.state?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel shrink>Region*</InputLabel>
                          <Select
                            {...register("region")}
                            label="Category"
                            id="outlined-adornment-category"
                            value={region ? region : null}
                            notched
                            error={errors?.region?.message}
                            onChange={(e) => setRegion(e.target.value)}
                          >
                            {state && Object.values(filterResult[state]).sort()?.map((title, index) => (
                              <MenuItem value={title} key={index}>
                                {title}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText error>
                            {errors?.region?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("startTime")}
                              label="From*"
                              name="startTime"
                              id="outlined-adornment-email"
                              onError={(newError) => setError(newError)}
                              minDate={endDate ? dayjs(endDate).subtract(1, 'month') : null}
                              maxDate={endDate ? dayjs(endDate) : dayjs()}
                              placeholder="From"
                              error={errors?.startTime?.message}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(newValue) => {
                                setStartDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              {...register("endDate")}
                              label="To*"
                              name="endDate"
                              id="outlined-adornment-email"
                              minDate={startDate ? dayjs(startDate) : null}
                              onError={(newError) => setError(newError)}
                              maxDate={toMaxDate}
                              disableFuture={true}
                              placeholder="To"
                              error={errors?.startTime?.message}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(newValue) => {
                                setEndDate(dayjs(newValue).format("YYYY-MM-DD"));
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText error>
                            {errors?.startTime?.message}
                          </FormHelperText>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Card>
                      <Stack direction="row" spacing={2}>
                        <FormControl variant="outlined" fullWidth>
                          <Button sx={{
                            minHeight: "41px"
                          }} type="button" onClick={() => handleClear()} variant="outlined">Clear</Button>
                        </FormControl>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </form>
              <UsageSummary graphData={usageSummaryGraphResult} type={monthDaily} monthDaily={monthDaily} module={individualContentModal} startDate={startDate} endDate={endDate} region={region} state={state} isMaskingEnabled={isMaskingEnabled} schoolType={schoolType} platform={platform} language={language} userType={userType} />
            </CustomTabPanel>
          </Box>
        </Paper>

      </Body>
    </>
  );
}
